import http from '../services/http';
import requestFormatter from '../services/requestFormatter';

import { MODULES_ENDPOINT, MARKETING_MODULES_ENDPOINT } from '../services/endpoints';

export default (() => {

    const create = (module) => {

        let formData = new FormData();
        requestFormatter.jsonToFormData(formData, module)
        return http.post(MODULES_ENDPOINT, formData);
    };

    const update = (module) => {

        const url = MODULES_ENDPOINT + '/' + module.id;
        let formData = new FormData();
        requestFormatter.jsonToFormData(formData, module)

        return http.post(url, formData);
    };

    const getAll = () => {

        return http.get(MODULES_ENDPOINT);
    };

    const getAllWithCourses = () => {

        return http.get(MARKETING_MODULES_ENDPOINT);
    };

    const remove = (module) => {

        const url = MODULES_ENDPOINT + '/' + module.id;

        return http.delete(url);
    };

    return {
        create,
        update,
        remove,
        getAll,
        getAllWithCourses
    };

})();


// WEBPACK FOOTER //
// ./services/modules.js